import { render } from "./ysdszConfigGurationCenter.vue?vue&type=template&id=07b10c24&scoped=true"
import script from "./ysdszConfigGurationCenter.vue?vue&type=script&lang=js"
export * from "./ysdszConfigGurationCenter.vue?vue&type=script&lang=js"

import "./ysdszConfigGurationCenter.vue?vue&type=style&index=0&id=07b10c24&scoped=true&lang=css"

import exportComponent from "E:\\web project\\web-serial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b10c24"]])

export default __exports__